import '@/lib/vender/govapp.js'
// import urlUtil from '@/utils/urlUtil'
// import Axios from 'axios'
// import store from '@/store'
// import { globalModule } from '@/store/moduleName'
import idApi from '@/api/esign/identification'

// const clientId = ''
const accountType = 'GOV_ENTITY'
const identityLevel = 'SATISFACTORY'
// const redirectUri = urlUtil.getRootUrl()
// const redirectUri = 'https://g2e.gov.mo' // use production account
const lang = 'ZH_HANT'

async function getAuthCode (euid, redirectUri, docCode, cb) {
  let authUrl = ''
  let params = 'accountType=' + accountType + '&euid=' + euid + '&identityLevel=' + identityLevel + '&redirectUri=' + redirectUri + '&language=' + lang + '&docCode=' + docCode
  // let params = 'accountType=' + accountType + '&clientId=' + clientId + '&euid=' + euid + '&identityLevel=' + identityLevel + '&redirectUri=' + redirectUri + '&language=ZH_HANT'
  await idApi.getAuthorizeUrl(resp => {
    authUrl = resp.data
    console.log('authUrl:  ' + authUrl)
  }, params)

  return new Promise((resolve, reject) => {
    window.govapp.requestIdentity({
      identity_level: 'SATISFACTORY',
      // identity_level: "HIGH",
      // identity_level: "VERY_HIGH",
      authorize_url: authUrl,
      reason: 'signing',
      redirect_url: redirectUri,
      success (resp) { // 成功回調
        // store.dispatch(globalModule + '/setErrorMessage', 'success resp' + resp.code)
        cb(resp.code)
        resolve()
      },
      fail (resp) { // 失敗回調
        // store.dispatch(globalModule + '/setErrorMessage', 'fail resp' + resp.code)
        cb(resp.code)
        resolve()
      },
      complete () { // 無論成功或失敗都回調

      }
    })
  })
}

function getCurrentLanguage () {
  return window.govapp.getCurrentLanaguage()
}

export {
  getAuthCode, getCurrentLanguage
}

export default {
  getAuthCode, getCurrentLanguage
}
